import React, { useEffect, useState } from "react";
import { toast } from "sonner";
import { motion } from "framer-motion";
import { api, formatApiError, formatCDF } from "../../lib/api";
import MobileHeader from "../../components/MobileHeader";
import BottomNav from "../../components/BottomNav";
import { Card, Badge } from "../../components/ui-kit";
import { Receipt, ClockCounterClockwise } from "@phosphor-icons/react";

export default function Wallet() {
  const [rides, setRides] = useState([]);

  useEffect(() => {
    api.get("/rides")
      .then(({ data }) => setRides((data || []).filter((r) => r.payment_method || r.payment_status)))
      .catch((e) => toast.error(formatApiError(e)));
  }, []);

  return (
    <div className="phone-frame phone-scroll-safe bg-premium-grad">
      <MobileHeader title="Paiements" />
      <div className="space-y-4 px-4 pt-2">
        <motion.div initial={{ opacity: 0, y: 10 }} animate={{ opacity: 1, y: 0 }}>
          <Card className="overflow-hidden p-0">
            <div className="relative overflow-hidden bg-gradient-to-br from-primary via-primary to-secondary px-5 py-6 text-primary-foreground">
              <div className="relative flex items-center gap-3">
                <div className="rounded-2xl bg-black/20 p-3"><Receipt size={24} weight="fill" /></div>
                <div>
                  <div className="text-[10px] font-bold uppercase tracking-widest opacity-80">NEXORA · Paiements</div>
                  <div className="mt-1 font-heading text-2xl font-bold">Historique seulement</div>
                </div>
              </div>
              <div className="relative mt-3 text-xs opacity-85">
                Le wallet interne n'est pas encore active. Les paiements se font en cash, M-Pesa, Airtel Money ou Orange Money directement avec le chauffeur.
              </div>
            </div>
          </Card>
        </motion.div>

        <Card className="p-0">
          <div className="flex items-center gap-2 border-b border-white/10 p-4">
            <ClockCounterClockwise size={18} weight="bold" />
            <div className="font-heading text-lg font-bold">Historique de paiement</div>
          </div>
          <div className="divide-y divide-white/5">
            {rides.length === 0 && (
              <div className="p-6 text-center text-xs text-muted-foreground">Aucun paiement</div>
            )}
            {rides.map((r) => (
              <div key={r.id} className="p-3" data-testid={`payment-history-${r.id}`}>
                <div className="flex items-center justify-between gap-3">
                  <div>
                    <div className="font-mono text-sm font-bold">{formatCDF(r.price)}</div>
                    <div className="mt-1 text-[10px] text-muted-foreground">
                      {r.created_at ? new Date(r.created_at).toLocaleString("fr-FR", { dateStyle: "short", timeStyle: "short" }) : "-"}
                    </div>
                  </div>
                  <div className="flex flex-wrap justify-end gap-1">
                    <Badge tone="primary">{r.payment_method}</Badge>
                    <Badge tone={r.payment_status === "COMPLETED" ? "success" : "warning"}>{r.payment_status}</Badge>
                  </div>
                </div>
                {r.payment_reference && <div className="mt-2 font-mono text-[11px] text-secondary">Ref: {r.payment_reference}</div>}
              </div>
            ))}
          </div>
        </Card>
      </div>
      <BottomNav role="customer" />
    </div>
  );
}
